export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_00.384090c9.jpg";